import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { "data-newsletter-sign-up-form": "" };
const _hoisted_2 = { class: "max-h-[66px] overflow-hidden" };
const _hoisted_3 = {
    key: 0,
    class: "absolute inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent",
    role: "status"
};
const _hoisted_4 = { class: "h-5 w-[35px] shrink-0 grow-0 overflow-hidden" };
const _hoisted_5 = {
    key: 0,
    class: "bg-green-50 px-5 py-3 text-center font-bold text-black lg:py-5"
};
const _hoisted_6 = {
    key: 0,
    class: "block w-full pt-3 text-left font-bold text-red"
};
import { ref, computed } from 'vue';
import SvgIcon from '@atoms/SvgIcon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'NewsletterSignUpForm',
    props: {
        submissionPage: { default: '' }
    },
    setup(__props) {
        const props = __props;
        const email = ref('');
        const emailNotValid = ref(false);
        const formError = ref(false);
        const formSuccess = ref(false);
        const formIsSubmitting = ref(false);
        const ajax = computed(() => window.WP_AJAX ?? {});
        const displayForm = computed(() => !formSuccess.value);
        /**
         * Computed error message shown under the form.
         */
        const errorMessage = computed(() => {
            if (emailNotValid.value)
                return 'Please enter a valid email address.';
            if (formError.value)
                return 'There was an error submitting the form. Please try again.';
            return '';
        });
        /**
         * Computed success message shown on successful submission.
         */
        const successMessage = computed(() => formSuccess.value ? 'Thank you for signing up!' : '');
        /**
         * Validates whether a given email string has a valid format.
         * @param emailStr - The email string to validate.
         * @returns `true` if the email is valid, otherwise `false`.
         */
        const isValidEmail = (emailStr) => {
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return regex.test(emailStr);
        };
        /**
         * Pushes a newsletter form submission event to the dataLayer for analytics.
         */
        const pushToDataLayer = () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'newsletter_form_submission',
                form_name: 'newsletter_signup',
                form_state: 'submit',
            });
        };
        /**
         * Sends the email form data to the backend via AJAX.
         * Updates form state based on success or failure.
         */
        const submitFormViaAjax = async () => {
            formIsSubmitting.value = true;
            const body = new FormData();
            body.append('action', 'newsletter_subscribe');
            body.append('nonce', ajax.value.nonce);
            body.append('email', email.value);
            try {
                const response = await fetch(ajax.value.url, {
                    method: 'POST',
                    body,
                });
                // eslint-disable-next-line no-unused-vars
                const data = await response.json();
                formSuccess.value = true;
                pushToDataLayer();
            }
            catch (error) {
                console.error(error);
                formError.value = true;
            }
            finally {
                formIsSubmitting.value = false;
            }
        };
        /**
         * Handles the form submission lifecycle:
         * - Validates email
         * - Redirects if a submission page is set
         * - Otherwise submits via AJAX
         */
        const handleFormSubmit = () => {
            if (!isValidEmail(email.value)) {
                emailNotValid.value = true;
                return;
            }
            emailNotValid.value = false;
            if (props.submissionPage) {
                const redirectUrl = `${props.submissionPage}?email=${encodeURIComponent(email.value)}`;
                window.location.href = redirectUrl;
                return;
            }
            submitFormViaAjax();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_TransitionGroup, {
                        "leave-active-class": "slide-up__enter-active",
                        "leave-from-class": "slide-up__enter-to",
                        "leave-to-class": "slide-up__enter-from"
                    }, {
                        default: _withCtx(() => [
                            (displayForm.value)
                                ? (_openBlock(), _createElementBlock("form", {
                                    key: 0,
                                    name: "Newsletter signup",
                                    class: "newsletter-form flex w-full items-center border-b border-black",
                                    onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
                                }, [
                                    _cache[3] || (_cache[3] = _createElementVNode("label", {
                                        class: "sr-only",
                                        for: "email"
                                    }, "Email", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((email).value = $event)),
                                        class: _normalizeClass([{ 'cursor-not-allowed': formIsSubmitting.value }, "block w-full border-none pl-0 focus:border-black focus:outline-none focus:ring-0"]),
                                        placeholder: "Email",
                                        id: "email",
                                        type: "email"
                                    }, null, 2), [
                                        [_vModelText, email.value]
                                    ]),
                                    _createElementVNode("button", {
                                        class: _normalizeClass([{ 'cursor-not-allowed': formIsSubmitting.value }, "flex shrink-0 items-center justify-center"]),
                                        type: "submit"
                                    }, [
                                        (formIsSubmitting.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _cache[1] || (_cache[1] = [
                                                _createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
                                            ])))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("span", {
                                            class: _normalizeClass([{ 'opacity-0': formIsSubmitting.value }, "flex shrink-0 items-center gap-1 text-sm font-bold text-black"])
                                        }, [
                                            _cache[2] || (_cache[2] = _createTextVNode(" Sign up ")),
                                            _createElementVNode("span", _hoisted_4, [
                                                _createVNode(SvgIcon, {
                                                    class: "-translate-x-2 transform transition-transform group-hover:translate-x-0",
                                                    name: "arrow"
                                                })
                                            ])
                                        ], 2)
                                    ], 2)
                                ], 32))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }),
                    _createVNode(_TransitionGroup, {
                        "enter-active-class": "slide-up__enter-active !delay-500",
                        "enter-from-class": "slide-up__enter-from",
                        "enter-to-class": "slide-up__enter-to"
                    }, {
                        default: _withCtx(() => [
                            (successMessage.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(successMessage.value), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]),
                (errorMessage.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(errorMessage.value), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
